import { TRoute } from 'gql/generated/graphql'

import { createRoutePlanningModel, IRoutePlanningModel } from 'features/RoutesPlanning/models'
import { getUniqueColor } from 'utils/style'

export interface IRoutesPlanningCollection {
  items: IRoutePlanningModel[]
  filterVisibleRoutes: () => IRoutePlanningModel[]
}

export const createRoutesPlanningCollection = (
  routes: TRoute[],
  visibleRoutesIds: string[],
  geometryLib: google.maps.GeometryLibrary | null
): IRoutesPlanningCollection => {
  const items = routes.map((route, routeIndex) => {
    const isVisible = visibleRoutesIds.includes(route.id)
    const routeColor = getUniqueColor(routeIndex)
    return createRoutePlanningModel(route, routeColor, isVisible, geometryLib)
  })
  return {
    items,
    filterVisibleRoutes: (): IRoutePlanningModel[] => {
      return items.filter((route) => route.isVisible)
    }
  }
}
